/**
 * Tenants listed here do not see upsell / upgrade messages (restricted view).
 * Add tenant ids as returned by the API (number or string).
 */
export const UPSELL_RESTRICTED_TENANT_IDS = Object.freeze([
  'de79da1e-53ae-4a18-9b8d-b3e5e6dbdf65',
  'd81bd774-d3d6-4f66-a372-c49cdeedf8be',
  'cfef7c49-05b0-4749-afe9-6a17e3c4adc7',
  '5d5610fa-e30f-498c-bd79-1fd48da9870c',
  '59e72a2c-3f92-499d-9d49-44e41674dca9',
  'd21d1fcf-eed5-4c5e-ab47-ecf7d0943904',
  '67b09c7b-8260-404a-b2bd-18ea1825e5f1',
  '0fcb4d0a-000c-459d-b9e1-dd7e7d5a16dc',
  '2753e540-c695-43c0-bb65-5deb98e174d6',
]);

const restrictedSet = new Set(UPSELL_RESTRICTED_TENANT_IDS.map((id) => String(id)));

/**
 * @param {string|number|null|undefined} tenantId
 * @returns {boolean} true if this tenant must not see upsell content
 */
export function isTenantUpsellRestricted(tenantId) {
  if (tenantId == null || tenantId === '') {
    return false;
  }
  return restrictedSet.has(String(tenantId));
}

/**
 * @param {string|number|null|undefined} tenantId
 * @returns {boolean} true if upsell content may be shown for this tenant
 */
export function shouldShowUpsellForTenant(tenantId) {
  return !isTenantUpsellRestricted(tenantId);
}
